import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyCOKitTtzzKz6-GYI_Dq0bBcMZDwVpKnTQ",
  authDomain: "plataforma-mested.firebaseapp.com",
  projectId: "plataforma-mested",
  storageBucket: "plataforma-mested.appspot.com",
  messagingSenderId: "716495806639",
  appId: "1:716495806639:web:58e6defac53601b381b45a",
  measurementId: "G-Z7CYK3KDBC"
};
// Get a Firestore instance
const app = firebase
  .initializeApp(firebaseConfig);
firebase.analytics();

const firestore = app.firestore();

firestore.enablePersistence();

export const db = firestore;
export const rdb = app.database();

export const storage = firebase.storage(app);

export const auth = app.auth();
